// Only called for the STORE_WITHOUT_GEOLOCALISATION code (the caller matches
// on the code, not on the text), whose messages look like
// "Stores without geolocalisation: 12, 34". The id list is whatever follows
// the first ": "; a message without one is shown whole. Deliberately not
// matching the prefix: the wording is the backend's, the code is the contract.
export function extractStoreIds(messages: string[]): string {
  const message = messages.join(", ");
  const [, stores] = message.split(": ");
  return stores || message;
}
